<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <!-- <div class="fileNo text-right" v-if="baseInfo.fileNo">{{baseInfo.fileNo}}</div> -->
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th class="thead font-bold" colspan="7">供地结果信息</th>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">项目名称:</td>
                        <td class="cols3" colspan="6">
                            {{ baseinfo.projectName }}
                        </td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">项目位置:</td>
                        <td class="cols3" colspan="6">
                            {{ baseinfo.location }}
                        </td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">项目城市:</td>
                        <td class="col2" colspan="3">
                            {{ baseinfo.area }}
                        </td>
                        <td class="col3 font-bold">电子监管号：</td>
                        <td class="col4" colspan="2">{{ baseinfo.ecNumber }}</td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">批准单位:</td>
                        <td class="col2" colspan="3">{{ baseinfo.approver }}</td>
                        <td class="col3 font-bold">合同签订日期:</td>
                        <td class="col4" colspan="2">{{ baseinfo.time || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">土地使用权人:</td>
                        <td class="cols3" colspan="3">{{ baseinfo.owner }}</td>
                        <td class="col1 font-bold">投资主体:</td>
                        <td class="cols3" colspan="2" :class="baseinfo.sourceStockCode != '' ? 'basefont pointer-cur' : ''"
                            @click="baseinfo.sourceStockCode != '' ? routerlinkid('/enterprises', baseinfo.sourceStockCode) : ''">
                            {{ baseinfo.sourceEnterprise || '-' }}</td>

                    </tr>
                    <tr>
                        <td class="col1 font-bold">土地用途:</td>
                        <td class="col2" colspan="3">{{ baseinfo.purpose }}</td>
                        <td class="col1 font-bold">土地使用年限:</td>
                        <td class="col2" colspan="2">{{ baseinfo.useYears }}</td>
                    </tr>
                    <tr>
                        <td class="col3 font-bold">行业分类:</td>
                        <td class="col4" colspan="3">
                            {{ baseinfo.industry }}
                        </td>
                        <td class="col1 font-bold">土地级别:</td>
                        <td class="col2" colspan="2">{{ baseinfo.level }}</td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">面积(亩<!--公顷-->):</td>
                        <td class="col2" colspan="3">{{ baseinfo.size.toFixed(2) }}</td>
                        <td class="col3 font-bold">成交价格(万元):</td>
                        <td class="col4" colspan="2">{{ baseinfo.amount }}</td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">约定容积率:</td>
                        <td class="font-bold">下限:</td>
                        <td>{{ baseinfo.volumeLower || '-' }}</td>
                        <td class="font-bold">上限:</td>
                        <td>{{ baseinfo.volumeUpper }}</td>
                        <td class="col3 font-bold">供地方式:</td>
                        <td class="col4">
                            {{ baseinfo.supplyMode }}
                        </td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">分期支付约定:</td>
                        <td class="cols3" colspan="6" style="margin: 0;padding: 0;">
                            <table cellspacing="0" cellpadding="2" border="0" class="paytable" width="100%">
                                <tr>
                                    <td class="pcol1 font-bold">支付期号</td>
                                    <td class="pcol2 font-bold">约定支付日期</td>
                                    <td class="pcol3 font-bold">约定支付金额(万元)</td>
                                    <td class="pcol4 font-bold">备注</td>
                                </tr>
                                <tr v-for="(payment, i) in baseinfo.payments" :key="i">
                                    <td class="pcol1">{{ payment.number }}</td>
                                    <td class="pcol2">{{ payment.time }}</td>
                                    <td class="pcol3">{{ payment.money }}{{ payment.unit }}</td>
                                    <td>{{ payment.remark }}</td>
                                </tr>
                            </table>
                        </td>
                        <!-- <td class="col3 font-bold">土地来源:</td>
                                <td class="col4" colspan="2">{{ baseinfo.origin || '-' }}</td> -->
                    </tr>

                    <tr>
                        <td class="col3 font-bold">约定交地时间:</td>
                        <td class="col4" colspan="6">{{ baseinfo.deliveryTime || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="col1 font-bold">约定开工时间:</td>
                        <td class="col2" colspan="4">{{ baseinfo.startTime || '-' }}</td>
                        <td class="col1 font-bold">实际开工时间:</td>
                        <td class="col2">{{ baseinfo.realStartTime || '-' }}</td>

                    </tr>
                    <tr>
                        <td class="col3 font-bold">约定竣工时间:</td>
                        <td class="col4" colspan="4">{{ baseinfo.endTime || '-' }}</td>
                        <td class="col3 font-bold">实际竣工时间:</td>
                        <td class="col4">{{ baseinfo.realEndTime || '-' }}</td>
                    </tr>

                </table>
                <ad :type="2"></ad>
                 <!--判断数组长度 -->
                <relatedBy v-if="extend.relatedByProjectCode && extend.relatedByProjectCode.length > 0"
                    :pageTitle="'关联项目'" :pageType="2"
                    :relatedByData="extend.relatedByProjectCode">
                </relatedBy>
                <relatedBy v-if="extend.relatedByCompanyName && extend.relatedByCompanyName.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.companyName + '）关联项目'" :pageType="1" :relatedByData="extend.relatedByCompanyName">
                </relatedBy>
            </div>
        </div>
    </div>
</template>

<script>
import relatedBy from '../components/relatedBy.vue';
export default {
    components: {
        relatedBy
    },
    data() {
        return {
            id: this.$route.query.id || null,
            baseinfo: {},
            extend: {}
        }
    },
    created() {

    },
    mounted() {
        this.getData();
        this.getRelated();
    },
    methods: {
        //获取相关数据
        getRelated() {
            let ajaxUrl = this.$api.common.Land.Related() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('相关拿地', res);
                this.extend = res.extend || {};
            }).catch((err) => { });

        },
        getData() {
            let ajaxUrl = this.$api.metall.Land.Detail() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('拿地数据详情', res);
                this.baseinfo = res.data || {};
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
        text-align: center;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>